import { nonEmptyStringValidator, ShowtimeFilterKey } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { FilmThumbnailMediaType } from '../../../components/film/thumbnail/types/media-type';
import { defaultFilmTrailerConfig, filmTrailerConfigValidatorSchema } from '../../../components/film/trailer/types/config';
import { FilmSynopsisLength } from '../../../types/film-synopsis-length';
import { getComponentFilterConfigValidator } from '../../../validators/component-filter-config';
export const defaultShowtimePickerConfig = {
    filmDetails: {
        show: true,
        mediaType: FilmThumbnailMediaType.Poster
    },
    filmSynopsisLength: FilmSynopsisLength.Shortest,
    showSiteDetails: true,
    showScreenName: false,
    attributeLegend: {
        show: true
    },
    customFilmActions: {
        show: true
    },
    actionButton: {
        show: true,
        showOnMessage: false
    },
    playTrailerButton: Object.assign(Object.assign({}, defaultFilmTrailerConfig), { show: true }),
    filmActionLink: {
        show: true
    }
};
export const showtimePickerFilmDetailsValidator = Validator.object({
    show: Validator.boolean(),
    mediaType: Validator.oneOf(Object.values(FilmThumbnailMediaType))
});
export const showtimePickerAttributeLegendValidator = Validator.object({
    show: Validator.boolean(),
    attributeFilterFn: Validator.optional(Validator.fn())
});
export const showtimePickerFilmActionLinkValidator = Validator.object({
    show: Validator.boolean(),
    urlFactory: Validator.optional(Validator.fn())
});
export const showtimePickerAllFilmsToggleValidator = Validator.object({
    show: Validator.boolean(),
    initialValue: Validator.boolean()
});
export const showtimePickerActionButtonValidator = Validator.object({
    show: Validator.boolean(),
    showOnMessage: Validator.boolean()
});
export const defaultShowtimePickerConfigValidatorSchema = {
    filmDetails: showtimePickerFilmDetailsValidator,
    filmSynopsisLength: Validator.oneOf(Object.values(FilmSynopsisLength)),
    showSiteDetails: Validator.boolean(),
    showtimeUrlFactory: Validator.optional(Validator.fn()),
    showScreenName: Validator.boolean(),
    filmUrlFactory: Validator.optional(Validator.fn()),
    attributeLegend: showtimePickerAttributeLegendValidator,
    customFilmActions: Validator.object({ show: Validator.boolean() }),
    actionButton: showtimePickerActionButtonValidator,
    playTrailerButton: Validator.object(Object.assign(Object.assign({}, filmTrailerConfigValidatorSchema), { show: Validator.boolean() })),
    filter: getComponentFilterConfigValidator(Object.values(ShowtimeFilterKey)),
    componentId: Validator.optional(nonEmptyStringValidator),
    filmActionLink: showtimePickerFilmActionLinkValidator
};
export const showtimePickerConfigValidator = Validator.object(defaultShowtimePickerConfigValidatorSchema);
